export class GetCommentsByRecordId {
  static readonly type = '[Info/Comments] - Get comments by record id';

  constructor(public recordId: string) {}
}

export class GetCommentsByParentId {
  static readonly type = '[Info/Comments] - Get comments by parent id';

  constructor(public recordId: string, public parentId: string, public lastEvaluatedKey: string | null) {}
}

export class PostComment {
  static readonly type = '[Info/Comments] - Post comment';

  constructor(public recordId: string, public userId: string, public comment: string) {}
}

export class PostReply {
  static readonly type = '[Info/Comments] - Post reply';

  constructor(public recordId: string, public userId: string, public comment: string, public parentId: string, public rootCommentId: string, public replyUserId: string) {}
}

export class ClearRepliesByParentId {
  static readonly type = '[Info/Comments] - Clear replies by parent id';

  constructor(public parentId: string) {}
}

export class VoteComment {
  static readonly type = '[Info/Comments] - Vote comment';

  constructor(public recordId: string, public commentId: string, public userId: string, public like: boolean, public rootCommentId?: string) {}
}

export class DeleteComment {
  static readonly type = '[Info/Comments] - Delete comment';

  constructor(public commentId: string) {}
}

export class DeleteCommentReply {
  static readonly type = '[Info/Comments] - Delete comment reply';

  constructor(public commentId: string, public rootCommentId: string) {}
}

export class OpenTextarea {
  static readonly type = '[Info/Comments] - Open textarea';

  constructor(public id: string) {}
}

export class CloseTextarea {
  static readonly type = '[Info/Comments] - Close textarea';
}
